import React from "react";
import { Modal, Button } from "react-bootstrap";
import LogoutRedIcon from "../icons/LogoutRedIcon"; // Adjust the import path as needed
import { all_routes } from "../feature-module/router/all_routes";
import { useNavigate } from "react-router-dom";
import { logOut } from "../services/auth.service";
import { toast } from "react-toastify";
import { clearStorage } from "../services/storage.service";
import { AxiosError } from "axios";
import { updateAuthorizationHeader } from "../services/http.service";
import { setHasSubscription, setPlanPermission, setToken } from "../core/data/redux/user/userSlice";
import { useDispatch } from "react-redux";

interface LogoutModalProps {
  show: boolean;
  onHide: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ show, onHide }) => {
  const routes: any = all_routes;
  const navigate = useNavigate();
  const dispatch: any = useDispatch();


  const handleConfirmLogout = async () => {
    try {
      const result = await logOut();
      toast.success(result?.data?.message);

      clearStorage();
      dispatch(setToken(null));
      dispatch(setHasSubscription(false));
      dispatch(setPlanPermission(null));
      navigate(routes.login);
      onHide();
      updateAuthorizationHeader();
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.error);
      }
      console.log(error);
    }
  };


  return (
    <Modal
      className="deleteModal"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="sm"
    >
      <Modal.Body className="text-center">
        <div className="mx-auto py-4">
          <LogoutRedIcon />
        </div>
        <h4>Logout</h4>
        <p>Are you sure want to logout?</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center gap-3">
        <Button className="btnWrp cancelBtn" onClick={onHide}>
          No
        </Button>
        <Button className="btnWrp" onClick={handleConfirmLogout}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;